export default "__VITE_ASSET__uavRli1i__"